/** Design setup / media / gallery feature reducers */
export async function loadDesignReducers() {
  const [
    designSetup,
    loginDesignSetup,
    posLoginDesignSetup,
    splashScreenDesignSetup,
    restaurantsDesignSetup,
    media,
    backScreenMedia,
    gallery,
  ] = await Promise.all([
    import('../reducers/DesignSetupReducer'),
    import('../reducers/LoginDesignSetupReducer'),
    import('../reducers/PosLoginDesignSetupReducer'),
    import('../reducers/SplashScreenDesignSetupReducer'),
    import('../reducers/RestaurantsDesignSetupReducer'),
    import('../reducers/MediaReducer'),
    import('../reducers/BackScreenMediaReducer'),
    import('../reducers/GalleryReducer'),
  ]);

  return {
    designSetup: designSetup.default,
    loginDesignSetup: loginDesignSetup.default,
    posLoginDesignSetup: posLoginDesignSetup.default,
    splashScreenDesignSetup: splashScreenDesignSetup.default,
    restaurantsDesignSetup: restaurantsDesignSetup.default,
    media: media.default,
    backScreenMedia: backScreenMedia.default,
    gallery: gallery.default,
  };
}
